<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Users Admin"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        
        <v-tabs v-model="tab" class="mt-4" background-color="#fdfdfd">
            <v-tab>All users</v-tab>
            <v-tab>Livestreamers</v-tab>

            <v-tab-item>
                <v-card flat>
                    <Authorized :tab="tab" />
                </v-card>
            </v-tab-item>

            <v-tab-item v-if="user.role.master || user.role.director">
                <v-card flat>
                    <Livestreamers :tab="tab" />
                </v-card>
            </v-tab-item>
        </v-tabs>
	</v-card>
</template>

<script>
import Users from '@/firebase/users'
import Authorized from '@/components/users/Authorized'
import Livestreamers from '@/components/users/Livestreamers'
import Pending from '@/components/users/Pending'

export default {
    data: () => ({
        tab: 0,
        pendingCount: 0
    }),
    components: {
        Authorized, 
        Pending,
        Livestreamers
    },
    mounted() {
        //this.init();
    },
    methods: {
        init() {
            let factor = '';
            
            if (this.user.role.master)  factor = 'master';
            if (this.user.role.director)  factor = {role:'director', center:this.user.center};

            Users.getAllByPending(factor)
                    .then(response => {
                        if (response.status == true) {
                            this.pendingCount = response.query.docs.length;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        countPending(e) {
            this.pendingCount = e;
        }
    }
}
</script>
